import {
  useShellAgents,
  useShellDrawer,
  useShellSelection,
} from '../../provider';
import { useAgentsCatalog } from '../../provider/queries';
import { AgentGroupList } from './AgentGroupList';
import { groupAgents, shortListGroups } from './agent-groups';
import styles from './ShellDrawer.module.css';

/** Default-view agents: every standard agent, with the tenant's custom
 *  agents behind a "Browse all agents (+M)" expander (see shortListGroups). */
export function AgentsSection() {
  // Kick off the catalog fetch the first time the drawer mounts.
  useAgentsCatalog();
  const agents = useShellAgents();
  const selection = useShellSelection();
  const drawer = useShellDrawer();

  const { groups, hidden: overflow } = shortListGroups(
    groupAgents(agents.allIds, agents.byId),
    selection.agentId
  );

  const handleSelect = (agentId: string) => {
    selection.selectAgent(agentId);
    drawer.close();
  };

  return (
    <section className={styles.section} aria-label="Agents">
      <AgentGroupList
        groups={groups}
        byId={agents.byId}
        selectedId={selection.agentId}
        onSelect={handleSelect}
      />
      {overflow > 0 ? (
        <button
          type="button"
          className={styles.moreRow}
          onClick={() => drawer.setView('all-agents')}
        >
          Browse all agents (+{overflow})
        </button>
      ) : null}
    </section>
  );
}
